import React from 'react';
import { x } from '@xstyled/styled-components';
import { t } from 'ttag';
import { useLightSwitchesAudioEffect } from '~/ui/audio-effect/useLightSwitchesAudioEffect';
import { CloseButton } from '~/ui/buttons/CloseButton';
import { Flex } from '~/ui/flex/Flex';
import { PickList } from '~/ui/pick-list/PickList';
import { Legend } from '../Header';
import { SettingsPages, useSettingsStore } from '../Store';
import { select } from '~/lib/select';
import { TrainingState, useTrainingStore } from '~/training/state';

const selector = (s: TrainingState) => select(s, 'darkMode', 'setDarkMode');

export const DarkModePage = () => {
  const { darkMode, setDarkMode } = useTrainingStore(selector);
  const MODES = [
    {
      label: 'Automatic',
      value: 'automatic'
    },
    {
      label: 'Dark',
      value: 'dark'
    },
    {
      label: 'Bright',
      value: 'bright'
    }
  ];

  const { page, setPage } = useSettingsStore();
  const [playAudioEffect] = useLightSwitchesAudioEffect();

  if (page !== SettingsPages.DarkMode) return null;

  return (
    <>
      <CloseButton onClick={() => setPage(SettingsPages.Root)} />
      <Flex variant="list">
        <x.fieldset p={0} m={0}>
          <Legend>{t`Theme`}</Legend>
          <PickList
            ungrouped
            items={MODES}
            selected={MODES.find(mode => mode.value === darkMode)}
            valueField="value"
            labelField="label"
            onSelect={item => {
              try {
                playAudioEffect();
              } catch (error) {
                // Silently ignore audio effect errors
              }
              setDarkMode(item.value);
              setPage(SettingsPages.Root);
            }}
          />
        </x.fieldset>
      </Flex>
    </>
  );
};
